import { renderMarketingPage, SUPPORT_EMAIL } from './shared.js';

const STEPS = [
  {
    icon: '🎁',
    title: 'Start free',
    text: 'Every new account gets a full free month to explore — browse and view free/community listings, no card required.',
  },
  {
    icon: '💳',
    title: 'Top up your wallet',
    text: 'Creating content and buying someone else\'s listing are pay-as-you-go, metered straight from your wallet — recharge any amount, spend only what you use.',
  },
  {
    icon: '📺',
    title: '₹100/month to keep viewing',
    text: 'After your free month, viewing your own content, anything you\'ve purchased, and free listings is ₹100/month (inclusive of taxes), auto-charged from your wallet.',
  },
];

const FAQS = [
  {
    q: 'What exactly costs ₹100/month?',
    a: 'Viewing — your own generated courses and topics, anything you\'ve purchased from the Library, and free/₹0 listings. It\'s billed once every 30 days and auto-debited from your wallet balance.',
  },
  {
    q: 'What isn\'t covered by the ₹100/month?',
    a: 'Creating new content and buying other people\'s listings are separate, pay-as-you-go charges from your wallet — you only pay for what you generate or purchase, on top of the monthly viewing charge.',
  },
  {
    q: 'What happens if my wallet balance is too low when it\'s due?',
    a: 'Nothing is deleted. Viewing is simply paused with a "recharge to continue" prompt — your content and purchases stay exactly as they are, and access resumes automatically the moment you top up.',
  },
  {
    q: 'Is the free month really free?',
    a: 'Yes — every new signup gets 30 days before the viewing charge ever applies, so you can explore free listings and try the platform with no payment details required.',
  },
  {
    q: 'What about schools and colleges?',
    a: 'Schools work differently: one prepaid seat licence covers all linked students (their viewing is sponsored by the school, with no personal wallet needed), and teachers get a free monthly creation quota. See <a href="#/schools">Simustage for schools</a>.',
  },
];

export function renderPricing(container, signedIn) {
  const body = `
    <main class="mkt-main">
      <section class="mkt-page-hero">
        <h1>Simple, pay-as-you-go pricing</h1>
        <p>No fixed tiers to pick between. Start free, top up your wallet only when you're creating or buying, and pay a flat ₹100/month to keep viewing.</p>
      </section>

      <section class="mkt-section">
        <div class="audience-grid">
          ${STEPS.map((s) => `
            <div class="audience-card" style="text-align:center;">
              <div class="feature-icon">${s.icon}</div>
              <h3>${s.title}</h3>
              <p style="color:var(--text-dim);margin:0;">${s.text}</p>
            </div>
          `).join('')}
        </div>
        <p class="pricing-note">
          All amounts are in INR and paid through Razorpay. ₹100/month is inclusive of taxes.
          Read our <a href="#/refund">Refund &amp; Cancellation Policy</a> or contact
          <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a> with billing questions.
        </p>
        <div style="text-align:center;margin-top:28px;">
          <a href="#/login" class="btn btn-primary btn-lg">Get started free</a>
        </div>
      </section>

      <section class="mkt-section mkt-section-alt">
        <div class="mkt-section-head">
          <h2>Frequently asked</h2>
        </div>
        <div class="faq-list">
          ${FAQS.map((f) => `
            <details class="faq-item">
              <summary>${f.q}</summary>
              <p>${f.a}</p>
            </details>
          `).join('')}
        </div>
      </section>
    </main>
  `;
  renderMarketingPage(container, '/pricing', signedIn, body);
}
